export default __webpack_public_path__ + "static/media/chain-7.52aa3fca.png";